import React from 'react';

import styled from 'styled-components';

import { getInitials } from 'helpers/strings';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  min-width: 0;
`;

const InitialsBadge = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid var(--dark-blue);
  background: var(--feather-blue);
  color: var(--dark-blue);
  font-size: 10px;
  font-family: var(--font-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const TextColumn = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Label = styled.span`
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Meta = styled.span`
  color: var(--text-secondary);
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type Props = {
  label?: React.ReactNode;
  email?: string;
  role?: string;
  showDetails?: boolean;
};

const OWNER_META_SEPARATOR = ' · ';

const CreateEditActionPlansModalOwnerLabel = ({ label, email, role, showDetails = false }: Props) => {
  const text = typeof label === 'string' ? label : '';
  if (!text.length) {
    return null;
  }

  const meta = [role, email].filter(Boolean).join(OWNER_META_SEPARATOR);

  return (
    <Container>
      <InitialsBadge>{getInitials(text)}</InitialsBadge>
      <TextColumn>
        <Label>{text}</Label>
        {showDetails && meta && <Meta>{meta}</Meta>}
      </TextColumn>
    </Container>
  );
};

export default CreateEditActionPlansModalOwnerLabel;
